import { render, staticRenderFns } from "./gerente.vue?vue&type=template&id=d3a96c24"
import script from "./gerente.vue?vue&type=script&lang=js"
export * from "./gerente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports